@if ({
  navigationItems: navigationItems$ | async,
  isLongBreadcrumbVisible: (isLongBreadcrumbVisible$ | async) ?? true,
  availableForms: (availableForms$ | async) ?? []
  }; as observables) {
  @if (observables.navigationItems) {
    <div>
      <ng-container *ngTemplateOutlet="observables.isLongBreadcrumbVisible ? longBreadcrumb : shortBreadcrumb" />
    </div>
  }
  <ng-template #shortBreadcrumb>
    <app-short-breadcrumb [breadcrumbs]="observables.navigationItems"
      [forms]="observables.availableForms"
      (breadcrumbClicked)="onBreadcrumbClick($event)"
      (formSelected)="onFormSelected($event)" />
  </ng-template>
  <ng-template #longBreadcrumb>
    <app-long-breadcrumb [breadcrumbs]="observables.navigationItems"
      [forms]="observables.availableForms"
      (homeClicked)="navigateToHomePage()"
      (breadcrumbClicked)="onBreadcrumbClick($event)"
      (formSelected)="onFormSelected($event)" />
  </ng-template>
}
